const e={MuiAutocomplete:{styleOverrides:{root:{"& .MuiInput-root.MuiInputBase-sizeSmall":{padding:"0.375rem"}}}}};export{e as default};
//# sourceMappingURL=MuiAutoComplete.js.map
